import React, { useContext } from 'react';

import { Grid, Skeleton, Table, TableBody, TableHead, TableRow } from '@mui/material';
import styled from 'styled-components';

import { PlannerContext } from '../../../PlannerContext';

const StyledTable = styled(Table)`
    margin-bottom: 2rem;
`;

const Spacer = styled.div`
    margin: 1rem;
`;

const PaddedSkeleton = styled(Skeleton)`
    margin: .5rem 0;
`;

export const PlannerDetailContent = () => {
    const { plannerData } = useContext(PlannerContext);
    console.log('PlannerDetailContent', plannerData);

    if (plannerData.loading) {
        return (
            <>
                <Grid container justifyContent="space-between">
                    <Grid item><Skeleton width={300} height={60}/></Grid>
                    <Grid item><Skeleton width={150} height={60}/></Grid>
                </Grid>
                <Spacer />
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <Spacer />
                <Grid container justifyContent="flex-end">
                    <Skeleton width={400} height={50}/>
                </Grid>
            </>
        );
    }

    return (
        <>
            <StyledTable>
                <TableHead>
                    <TableRow>
                    </TableRow>
                </TableHead>
                <TableBody>
                </TableBody>
            </StyledTable>
        </>
    );
};
